import Objective from './Objective';
import ProgressBar from './ProgessBar';

function Goal(props) {
    const percentComplete = 
    props.year in props.data.progress
    ? Math.floor(props.data.progress[props.year].percentComplete / props.data.progress[props.year].weight) || 0
    : 0
    const progressBarElement =
        props.year in props.data.progress && !props.data.doNotCount
        ? <ProgressBar percentComplete={percentComplete} />
        : <div className="progress-bar progress-bar-value">n/a</div>

    const objectives = props.objectives.map((objective) => <Objective key={objective.id} data={objective} year={props.year || "all"} viewLevel={props.viewLevel} />)

    return (
        <div className="dashboard-section goal">
            <header>{props.data.name}</header>
            <div className="description">{props.data.description}</div>
            {/*progressBarElement*/}
            <div className="objectives">
                {objectives}
            </div>
        </div>
    );
}

export default Goal;